(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldController', SegmentFieldController);

    SegmentFieldController.$inject = ['$state', 'DataUtils', 'SegmentField', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SegmentFieldController($state, DataUtils, SegmentField, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = {
            label: pagingParams.label,
            providerName: pagingParams.providerName,
            providerSegment: pagingParams.providerSegment,
            name: pagingParams.name,
            type: pagingParams.type
        };

        if (!pagingParams.firstRun) {
            loadAll();
        }

        function loadAll () {
            SegmentField.query({
                label: pagingParams.label,
                providerName: pagingParams.providerName,
                providerSegment: pagingParams.providerSegment,
                name: pagingParams.name,
                type: pagingParams.type,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.segmentFields = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                label: vm.searchQuery.label,
                providerName: vm.searchQuery.providerName,
                providerSegment: vm.searchQuery.providerSegment,
                name: vm.searchQuery.name,
                type: vm.searchQuery.type,
                firstRun: false
            });
        }

        function search(searchQuery) {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.searchQuery = {
                label: null,
                providerName: null,
                providerSegment: null,
                name: null,
                type: null
            };
            vm.transition();
        }
    }
})();
